import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b75a3ad8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_2 = {
  colspan: "100%",
  class: "highlighted-row"
}
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("table", null, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _hoisted_1,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allergenValues, (allergenValue) => {
            return (_openBlock(), _createElementBlock("th", { key: allergenValue }, _toDisplayString(_ctx.Lang.getI18N('allergen.' + allergenValue)), 1))
          }), 128))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedElements, (group, elementType) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: elementType }, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_2, _toDisplayString(elementType), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (element, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", null, _toDisplayString(element.getName()), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allergenValues, (allergenValue) => {
                  return (_openBlock(), _createElementBlock("td", { key: allergenValue }, [
                    (_ctx.elementHasAllergen(element, allergenValue))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_3, "X"))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            }), 128))
          ], 64))
        }), 128))
      ])
    ])
  ]))
}